var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSqlLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "color",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5 10.5v3.5h1c.99 0 1.87.49 2.42 1.24.8-.76 1.88-1.24 3.08-1.24h1c1.2 0 2.28.48 3.08 1.24.55-.75 1.43-1.24 2.42-1.24.35 0 .69.06 1 .18v-3.68z",
    fill: "#ffc107"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 13c-.717 0-7-.07-7-2.5v-4h14v4c0 2.43-6.283 2.5-7 2.5z",
    fill: "#ffd54f"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12 9c-.717 0-7-.07-7-2.5v-4h14v4c0 2.43-6.283 2.5-7 2.5z",
    fill: "#ffc107"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m12 5c-.717 0-7-.07-7-2.5 0-2.43 6.283-2.5 7-2.5s7 .07 7 2.5-6.283 2.5-7 2.5z",
    fill: "#ffd54f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m5 10.5v3.5h1c.99 0 1.87.49 2.42 1.24.8-.76 1.88-1.24 3.08-1.24h.5v-1c-.717 0-7-.07-7-2.5z",
    fill: "#dea806"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m5 6.5v4c0 2.43 6.283 2.5 7 2.5v-4c-.717 0-7-.07-7-2.5z",
    fill: "#deb945"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m5 2.5v4c0 2.43 6.283 2.5 7 2.5v-4c-.717 0-7-.07-7-2.5z",
    fill: "#dea806"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m12 0c-.717 0-7 .07-7 2.5 0 2.43 6.283 2.5 7 2.5z",
    fill: "#deb945"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2196f3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 18.5c0-1.378-1.121-2.5-2.5-2.5h-1c-1.379 0-2.5 1.122-2.5 2.5v3c0 1.378 1.121 2.5 2.5 2.5h1c.336 0 .656-.069.949-.189.168.114.356.189.551.189.256 0 .512-.098.707-.293.345-.345.367-.869.104-1.258.121-.293.189-.613.189-.949zm-4 3v-3c0-.276.225-.5.5-.5h1c.275 0 .5.224.5.5v2.155c-.384-.226-.878-.192-1.207.138s-.364.824-.138 1.207h-.155c-.275 0-.5-.224-.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21 24h-3c-.553 0-1-.448-1-1v-6c0-.552.447-1 1-1s1 .448 1 1v5h2c.553 0 1 .448 1 1s-.447 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.5 24h-1.5c-.553 0-1-.448-1-1s.447-1 1-1h1.5c.275 0 .5-.224.5-.5s-.225-.5-.5-.5c-1.379 0-2.5-1.122-2.5-2.5s1.121-2.5 2.5-2.5h1.5c.553 0 1 .448 1 1s-.447 1-1 1h-1.5c-.275 0-.5.224-.5.5s.225.5.5.5c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5z"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m15 20.063h-2v.593c-.162-.095-.344-.145-.525-.145-.247 0-.492.092-.683.282-.329.33-.364.824-.138 1.207h-.154c-.275 0-.5-.224-.5-.5v-1.437h-2v1.437c0 1.378 1.121 2.5 2.5 2.5h1c.336 0 .656-.069.949-.189.168.114.356.189.551.189.256 0 .512-.098.707-.293.345-.345.367-.869.104-1.258.121-.293.189-.613.189-.949z",
    fill: "#1d83d4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m19 20.063h-2v2.937c0 .552.447 1 1 1h3c.553 0 1-.448 1-1s-.447-1-1-1h-2z",
    fill: "#1d83d4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m6.544 20.063h-3.994c.458.571 1.162.937 1.95.937.275 0 .5.224.5.5s-.225.5-.5.5h-1.5c-.553 0-1 .448-1 1s.447 1 1 1h1.5c1.379 0 2.5-1.122 2.5-2.5 0-.535-.169-1.031-.456-1.437z",
    fill: "#1d83d4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlLogo);
export default __webpack_public_path__ + "static/media/SQL_Logo.497eb96d6109e314982598ae9e98cc5d.svg";
export { ForwardRef as ReactComponent };